import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { LEGAL_PAGES } from '../data/meta'

export default function TermsOfService() {
  return (
    <>
      <SEO
        title={LEGAL_PAGES.terms.title}
        description={LEGAL_PAGES.terms.description}
        canonical={LEGAL_PAGES.terms.url || '/terms'}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: LEGAL_PAGES.terms.title,
          description: LEGAL_PAGES.terms.description,
        }}
      />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content">
          <h1>Terms of Service</h1>
          <p>Last updated: July 2026</p>

          <h2>1. Acceptable Use</h2>
          <p>
            You agree to use TRED-EX AI products in compliance with all applicable Indian and international laws.
            You may not reverse-engineer, resell, or misuse any service.
          </p>

          <h2>2. Subscriptions & Payments</h2>
          <p>
            Paid plans are billed through Razorpay. Subscriptions renew automatically unless cancelled before the renewal date.
          </p>

          <h2>3. Cancellation</h2>
          <p>
            You may cancel your subscription at any time from your account settings. Access continues until the end of the current billing period.
          </p>

          <h2>4. Service Availability</h2>
          <p>
            We strive for 99.9% uptime but do not guarantee uninterrupted access. Maintenance windows will be announced in advance.
          </p>

          <h2>5. Contact</h2>
          <p>
            For questions, contact support@tredextechnology.in or business@tredextechnology.in, or visit our contact page.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
